// extracted by mini-css-extract-plugin
module.exports = {"header":"XD0j7","logo":"pWynf","container":"mOFRz"};